import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { AccountSelectableColumns, ChildAccountSelectableColumns, JournalUserType, UserType, maxChildLevelForChartOfAccountsView, typeJournalAddEditText, typeJournalDebitCreditCalculation } from "src/app/finance/constants/constants";
import { FinanceService } from "src/app/finance/finance.service";
import { FinanceUtilityService } from "src/app/finance/util/finance-utility.service";
import { ChannelN } from "../../models/channel.model";
import { AccountModuleId } from "../../constants/modules.constant";
import { SharedChannelService } from "../../services/channel.service";
import { Severity, Status } from "src/app/configurations/finance/constants/constants";
import { TitleCasePipe } from "@angular/common";
import { AccountService } from "src/app/accounts/accountService";
import { IJournal } from "src/app/finance/models/journal.model";
import { IFinanceAccountTransaction } from "src/app/finance/models/finance-account-transaction.model";
import { ImportserialService } from "../../services/importserial.service";
import { Subject, debounceTime, distinctUntilChanged, takeUntil, tap } from "rxjs";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountFlatteningService } from "../../../../inventory/sales-order/services/account-flattening.service";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { ProductsService } from "src/app/inventory/products/products.service";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { IPostingPeriodDetails } from "../posting-period-selector/models/posting-period.model";

@Component({
    selector: "app-journal-entry-view",
    templateUrl: "./journal-entry-view.component.html",
    styleUrls: ["./journal-entry-view.component.scss"],
})
export class JournalEntryViewComponent implements OnInit, OnChanges , OnDestroy {

    @Input() accountsTransactionMasterID;
    @Input() fromBill: boolean = false;
    @Input() isView;
    @Input() allAccounts;
    @Input() confirmVoid : boolean = false;
    @Output() onSuccessfullAddEdit = new EventEmitter<typeJournalAddEditText>();
    @Output() onCancelEdit = new EventEmitter<any>();
    @Output() isJEVoided = new EventEmitter<any>();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    journalDetails: IJournal = {} as IJournal;

    //view to edit
    isAdjustedEntry = false;
    transactionDate: Date;
    accountTypes = [];
    journalForm: FormGroup;
    journalUserType = JournalUserType;
    totalDebit: Number = 0;
    totalCredit: Number = 0;
    accountChannelFor = [UserType.Customer, UserType.Other];
    vendorChannelFor = [UserType.Vendor];
    employeeChannelFor = [UserType.Employee];
    accountChannels: ChannelN[] = [];
    vendorAccounts = [];
    userType: UserType.Customer | UserType.Vendor | UserType.Employee | UserType.Other = UserType.Other;
    accountChannelDisabledFor = [UserType.Other];
    memo = "";
    classes: any[] = [];
    isVoided: boolean = false;
    // fraction digits
    fractionDigits: number = 0;
    statementMessage: string = "";
    allUser :any[] = [];

    //assign user
    userIndex = 0;
    displayUserList = false;
    selectedUserType;
    userlists = [];
    selectedAccountChannel;
    assignedUser;
    selectedUserList;
    accSelectableColumns = AccountSelectableColumns;
    otherName = "";
    searchValue = "";
    private searchSubject = new Subject<string>();

    noCaseFindOrLoadingText = "Loading...";
    totalRecord = 0;
    pageSize: number = 15;
    pageNumber: number = 1;
    first: number = 0;
    
    isAllowPostingPeriod: boolean = false;
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;

    constructor(
        private financeService: FinanceService,
        private appMainService: AppMainService,
        private messageService: MessageService,
        public app: AppMainComponent,
        private financeUtilityService: FinanceUtilityService,
        private fb: FormBuilder,
        private sharedChannelService: SharedChannelService,
        private titlecasePipe: TitleCasePipe,
        private accountService: AccountService,
        private accountServiceN: AccountServiceN,
        private confirmationService: ConfirmationService,
        private importService: ImportserialService,
        private accountFlatteningService: AccountFlatteningService,
        private salesOrderService: SalesOrderService,
        private productsService: ProductsService,
        private utilityService: UtilityService
    ) { }

    ngOnInit(): void {
        this.getFractionDigits();
        this.getAllUsers();
        this.setupSearch();
        this.getIsetting();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getAccountChannels(AccountModuleId);
        this.getAllClasses();
        this.getAllVendorSearch(null);
        if (changes?.accountsTransactionMasterID?.currentValue) {
            this.accountsTransactionMasterID = changes.accountsTransactionMasterID.currentValue;
        }
        this.getAccountTransactionMasterById(this.accountsTransactionMasterID);
        if (changes.allAccounts && changes.allAccounts.currentValue) {
            this.allAccounts = changes.allAccounts.currentValue;
            this.accountTypes = this.financeUtilityService.getAccountTypes(false, true, this.allAccounts, false, 1, maxChildLevelForChartOfAccountsView);
        }

        this.transactionDate = this.app._showDateTimeWithZone(this.journalDetails?.transactionDate);
        this.journalForm = this.fb.group({
            // quantities: this.fb.array([this.newQuantity(), this.newQuantity()]),
            quantities: this.fb.array([]),
        });
    }
    getIsetting() {
        this.appMainService.isShowSpinner("loadISettings");
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
        this.appMainService.isHideSpinner("loadISettings");
    }
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => { },
            });
    }
    getAllUsers() {
        this.salesOrderService.getAllUser().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
                this.allUser = resp;
            });
    }
    getAccountTransactionMasterById(id) {
        this.journalDetails = null;
        this.appMainService.isShowSpinner("loadDetails");
        this.financeService.getAccountTransactionMasterById(id).subscribe(
            (res) => {
                this.journalDetails = res;
                this.isVoided = res?.isVoided;
                this.isJEVoided.emit(this.isVoided);
                this.transactionDate = this.app._showDateTimeWithZone(this.journalDetails?.transactionDate);
                this.currentPostingPeriodInfo = {
                    postingDate: this.journalDetails?.postingDate,
                    postingMonth: this.journalDetails?.postingMonth,
                    postingYear: this.journalDetails?.postingYear
                };
                this.appMainService.isHideSpinner("loadDetails");
                if (this.isView == false) {
                    this.editJournalEntry(this.journalDetails);
                }
            },
            (err) => {
                this.appMainService.isHideSpinner("loadDetails");
                this.showErrorMsg(err);
            },
        );
    }
    close() {
        this.onSuccessfullAddEdit.emit("Edit");
    }
    voidOrDelete(isVoid: boolean) {
        if (!!this.statementMessage) {
            this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
        } else {
            this.confirmVoidDelete(isVoid);
        }
    }
    confirmVoidDelete(isVoid: boolean) {
        const isVoidStatus = isVoid ? "Void" : "Delete";
        this.confirmationService.confirm({
            message: `Do you want to ${isVoidStatus} this Journal Entry?`,
            header: `${isVoidStatus} Confirmation`,
            icon: "pi pi-exclamation-triangle",
            key :"account-recivable-payable-dialog",
            accept: () => {
                this.financeService.bankEntriesVoidDelete(this.accountsTransactionMasterID, isVoid, "RemoveManualJournalEntry", "journalId").subscribe((resp) => {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: `${isVoidStatus}${isVoid ? "ed" : "d"} Successfully...`,
                    });
                    this.onSuccessfullAddEdit.emit("Edit");
                    // journalViewObj.accountsTransactionMasterID
                },
                    (err) => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: err?.error?.Message ?? "Error occurred...",
                        });
                    });
            },
        });
    }

    showErrorMsg(err) {
        this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: "Error occurred...",
        });
    }

    //#region view to edit

    quantities(): FormArray {
        return this.journalForm.get("quantities") as FormArray;
    }
    newQuantity(): FormGroup {
        return this.fb.group({
            selectedAccountTypes: ["", Validators.required],
            debit: [""],
            credit: [""],
            memo: [""],
            userType: [this.journalUserType[2], Validators.required],
            channel: [""],
            selectedAccountDD: ["", Validators.required],
            class: [""],
            id: [0],
        });
    }

    addQuantity() {
        this.quantities().push(this.newQuantity());
    }

    removeQuantity(i: number) {
        this.quantities().removeAt(i);
        this.calTotalDebit("Delete");
        this.calTotalCredit("Delete");
    }
    onSelectAccountType(e: any, i: number) {
        const accReceiveable = this.journalForm.value.quantities.find((x, index) => x?.selectedAccountTypes?.value?.accountType?.name?.toLowerCase() == "account receivable" && index != i);
        const accPayable = this.journalForm.value.quantities.find((x, index) => x?.selectedAccountTypes?.value?.accountType?.name?.toLowerCase() == "account payable" && index != i);
        if (e?.node?.value?.accountType?.name?.toLowerCase() == "account receivable") {
            if (accReceiveable || accPayable) {
                setTimeout(() => {
                    this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").setValue(null);
                    this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountTypes").setValue(null);
                    this.accountRecivablePayableSelectionDialog();
                }, 0);
                return false;
            }
            const uType = this.journalUserType.find((x) => x.id == 1);
            this.journalForm.get("quantities")["controls"].at(i).get("userType").setValue(uType);
            this.journalForm.get("quantities")["controls"].at(i).get("userType").setValidators([Validators.required]);
            this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").setValidators([Validators.required]);
            this.journalForm.get("quantities")["controls"].at(i).get("userType").disable();
            this.journalForm.get("quantities")["controls"].at(i).get("userType").updateValueAndValidity();
            this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").updateValueAndValidity();
        } else if (e?.node?.value?.accountType?.name?.toLowerCase() == "account payable") {
            if (accReceiveable || accPayable) {
                setTimeout(() => {
                    this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").setValue(null);
                    this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountTypes").setValue(null);
                    this.accountRecivablePayableSelectionDialog();
                }, 0);
                return false;
            }
            const uType = this.journalUserType.find((x) => x.id == 2);
            this.journalForm.get("quantities")["controls"].at(i).get("userType").setValue(uType);
            this.journalForm.get("quantities")["controls"].at(i).get("userType").setValidators([Validators.required]);
            this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").setValidators([Validators.required]);
            this.journalForm.get("quantities")["controls"].at(i).get("userType").disable();
            this.journalForm.get("quantities")["controls"].at(i).get("userType").updateValueAndValidity();
            this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").updateValueAndValidity();
        } else {
            const uType = this.journalUserType.find((x) => x.id == 1);
            this.journalForm.get("quantities")["controls"].at(i).get("userType").setValue(uType);
            this.journalForm.get("quantities")["controls"].at(i).get("userType").clearValidators();
            this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").clearValidators();
            this.journalForm.get("quantities")["controls"].at(i).get("userType").enable();
            this.journalForm.get("quantities")["controls"].at(i).get("userType").updateValueAndValidity();
            this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").updateValueAndValidity();
        }
    }
    onchangeDebit(e, i) {
        // this.journalForm.get("quantities")["controls"].at(i).get("credit").value = 0;
        // if (e.value) {
        //     // this.journalForm.get("quantities")["controls"].at(i).get("credit").disable();
        // } else {
        //     this.journalForm.get("quantities")["controls"].at(i).get("credit").enable();
        // }
        // // this.calTotalDebit();
    }

    onchangeCredit(e, i) {
        // this.journalForm.get("quantities")["controls"].at(i).get("debit").value = 0;
        // if (e.value) {
        //     // this.journalForm.get("quantities")["controls"].at(i).get("debit").disable();
        // } else {
        //     this.journalForm.get("quantities")["controls"].at(i).get("debit").enable();
        // }
        // // this.calTotalCredit();
    }
    calculateTotalDebitAmount() {
        this.totalDebit = 0;
        let arr = this.journalForm.value.quantities;
        for (let s of arr) {
            if (s.debit == undefined || s.debit == null) {
                s.debit = 0;
            }
            this.totalDebit = Number(this.totalDebit) + Number(s.debit);
        }
    }
    calTotalDebit(type: typeJournalDebitCreditCalculation = null, index: number = -1) {
        if (index != -1 && this.journalForm.get("quantities")["controls"].at(index).get("debit").value > 0) {
            this.journalForm.get("quantities")["controls"].at(index).get("credit").setValue(0);
        }
        this.calculateTotalDebitAmount();
        this.calculateTotalCreditAmount();
        if (type != "Delete") {
            if (this.totalDebit > this.totalCredit) {
                if (index != -1 && !this.quantities().at(index + 1)) {
                    this.addQuantity();
                }
                let arr1 = this.journalForm.value.quantities;
                this.journalForm
                    .get("quantities")
                ["controls"].at(arr1.length - 1)
                    .get("credit")
                    .setValue(Number(Number(this.totalDebit) - Number(this.totalCredit)));
            } else if (this.totalDebit < this.totalCredit) {
                if (index != -1 && !this.quantities().at(index + 1)) {
                    this.addQuantity();
                }
                let arr1 = this.journalForm.value.quantities;
                this.journalForm
                    .get("quantities")
                ["controls"].at(arr1.length - 1)
                    .get("debit")
                    .setValue(Number(Number(this.totalCredit) - Number(this.totalDebit)));
            }
            this.calculateTotalDebitAmount();
            this.calculateTotalCreditAmount();
        }
    }

    calculateTotalCreditAmount() {
        this.totalCredit = 0;
        for (let s of this.journalForm.value.quantities) {
            if (s.credit == undefined || s.credit == null) {
                s.credit = 0;
            }
            this.totalCredit = Number(this.totalCredit) + Number(s.credit);
        }
    }
    calTotalCredit(type: typeJournalDebitCreditCalculation = null, index: number = -1) {
        if (index != -1 && this.journalForm.get("quantities")["controls"].at(index).get("credit").value > 0) {
            this.journalForm.get("quantities")["controls"].at(index).get("debit").setValue(0);
        }
        this.calculateTotalCreditAmount();
        this.calculateTotalDebitAmount();
        if (type != "Delete") {
            if (this.totalCredit > this.totalDebit) {
                if (index != -1 && !this.quantities().at(index + 1)) {
                    this.addQuantity();
                }
                let arr1 = this.journalForm.value.quantities;
                this.journalForm
                    .get("quantities")
                ["controls"].at(arr1.length - 1)
                    .get("debit")
                    .setValue(Number(Number(this.totalCredit) - Number(this.totalDebit)));
            } else if (this.totalCredit < this.totalDebit) {
                if (index != -1 && !this.quantities().at(index + 1)) {
                    this.addQuantity();
                }
                let arr1 = this.journalForm.value.quantities;
                this.journalForm
                    .get("quantities")
                ["controls"].at(arr1.length - 1)
                    .get("credit")
                    .setValue(Number(Number(this.totalDebit) - Number(this.totalCredit)));
            }
            this.calculateTotalCreditAmount();
            this.calculateTotalDebitAmount();
        }
    }

    getAccountChannels(id: number) {
        this.sharedChannelService.getChannels(id).subscribe({
            next: (res: ChannelN[]) => {
                this.accountChannels = res;
            },
            error: (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        });
    }
    onSelectUserTyeps(event, i) {
        if (event.value.name == UserType.Customer) {
            this.userType = UserType.Customer;
            // this.getAllAccountSearch(null);
        } else if (event.value.name == UserType.Vendor) {
            this.userType = UserType.Vendor;
            // this.getAllVendorSearch(null);
        } else if (event.value.name == UserType.Employee) {
            this.userType = UserType.Employee;
        } else {
            this.userType = UserType.Other;
        }
        this.journalForm.get("quantities")["controls"].at(i).get("channel").setValue(null);
        this.journalForm.get("quantities")["controls"].at(i).get("selectedAccountDD").setValue(null);
    }
    filterAccount(event, index: number) {
        let query = event.query;
        query = event.query;
        let channelId = this.journalForm?.get("quantities")["controls"]?.at(index)?.get("channel")?.value?.id;

        this.appMainService.isShowSpinner('getAccountList');
        this.accountServiceN.getAccountsByNameWithHierarchy(channelId, query)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.journalForm.get("quantities")["controls"].at(index).get("selectedAccountDD")["customerAccOptions"] = this.accountFlatteningService.flattenAccounts(response);
                    }
                    this.appMainService.isHideSpinner('getAccountList');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getAccountList');
                },
                complete: () => {
                    this.appMainService.isHideSpinner('getAccountList');
                }
            });
    }
    // getAllAccountSearch(event: any, index?: number): void {
    //     let data = {
    //         search: event?.filter ?? "",
    //         channelId: this.journalForm?.get("quantities")["controls"]?.at(index)?.get("channel")?.value?.id,
    //     };

    //     const requestModel: GelAllAccountRequestModel = {
    //         channelId: data.channelId,
    //         stageId: null,
    //         isActive: true,
    //         globalSearchValue: data.search,
    //         selectableColumns: [
    //             { columnName: "businessName", isCustom: false },
    //             { columnName: "sequenceNumber", isCustom: false },
    //             { columnName: "nameWithSequenceNumber", isCUstom: false },
    //         ],
    //         filter: null,
    //         pageSize: 0,
    //         pageNumber: 0,
    //         sortByColumn: null,
    //         isSortByDescending: true,
    //         filterInColumns: [],
    //     };

    //     this.appMainService.isShowSpinner("getAccountList");

    //     this.accountServiceN
    //         .getAccountsList(requestModel)
    //         .pipe(takeUntil(this.ngUnsubscribe$))
    //         .subscribe({
    //             next: (accounts1) => {
    //                 if (accounts1) {
    //                     const accounts = accounts1?.list?.length > 0 ? accounts1?.list.filter((r) => r.statusId == 1).slice(0, 1000) : [];
    //                     this.journalForm.get("quantities")["controls"].at(index).get("selectedAccountDD")["customerAccOptions"] = accounts?.slice(0, 500) ?? [];
    //                 }
    //                 this.appMainService.isHideSpinner("getAccountList");
    //             },
    //             error: (error) => {
    //                 this.appMainService.isHideSpinner("getAccountList");
    //             },
    //             complete: () => {
    //                 this.appMainService.isHideSpinner("getAccountList");
    //             },
    //         });
    // }

    getAllVendorSearch(event: any): void {
        this.financeService.getVendorNames().then((data) => {
            this.vendorAccounts = data;
            if (this.vendorAccounts?.length > 0) {
                this.vendorAccounts = this.vendorAccounts.filter((x) => x?.isActive == Status.ACTIVE);
            }
        });
    }
    onChangeAccountChannel(index) {
        this.journalForm.get("quantities")["controls"].at(index).get("selectedAccountDD").setValue(null);

        // let data = {
        //     search: "",
        //     channelId: this.journalForm?.get("quantities")["controls"]?.at(index)?.get("channel")?.value?.id,
        // };
        // const requestModel: GelAllAccountRequestModel = {
        //     channelId: data.channelId,
        //     stageId: null,
        //     isActive: true,
        //     globalSearchValue: data.search,
        //     selectableColumns: [
        //         { columnName: "businessName", isCustom: false },
        //         { columnName: "sequenceNumber", isCustom: false },
        //         { columnName: "nameWithSequenceNumber", isCUstom: false },
        //     ],
        //     filter: null,
        //     pageSize: 0,
        //     pageNumber: 0,
        //     sortByColumn: null,
        //     isSortByDescending: true,
        //     filterInColumns: [],
        // };

        // this.appMainService.isShowSpinner("getAccountList");

        // this.accountServiceN
        //     .getAccountsList(requestModel)
        //     .pipe(takeUntil(this.ngUnsubscribe$))
        //     .subscribe({
        //         next: (accounts1) => {
        //             if (accounts1) {
        //                 const accounts = accounts1?.list?.length > 0 ? accounts1?.list.filter((r) => r.statusId == 1).slice(0, 1000) : [];
        //                 this.journalForm.get("quantities")["controls"].at(index).get("selectedAccountDD")["customerAccOptions"] = accounts?.slice(0, 500) ?? [];
        //                 this.journalForm.get("quantities")["controls"].at(index).get("selectedAccountDD").setValue(accounts[0]);
        //             }
        //             this.appMainService.isHideSpinner("getAccountList");
        //         },
        //         error: (error) => {
        //             this.appMainService.isHideSpinner("getAccountList");
        //         },
        //         complete: () => {
        //             this.appMainService.isHideSpinner("getAccountList");
        //         },
        //     });
    }

    // setAccountDDValue(channelId: any, accountId: number, formGroup: FormGroup) {
    //     const requestModel: GelAllAccountRequestModel = {
    //         channelId: channelId,
    //         stageId: null,
    //         isActive: true,
    //         globalSearchValue: "",
    //         selectableColumns: [
    //             { columnName: "businessName", isCustom: false },
    //             { columnName: "sequenceNumber", isCustom: false },
    //             { columnName: "nameWithSequenceNumber", isCUstom: false },
    //         ],
    //         filter: null,
    //         pageSize: 0,
    //         pageNumber: 0,
    //         sortByColumn: null,
    //         isSortByDescending: true,
    //         filterInColumns: [],
    //     };
    //     this.appMainService.isShowSpinner("getAccountList");
    //     this.accountServiceN
    //         .getAccountsList(requestModel)
    //         .pipe(takeUntil(this.ngUnsubscribe$))
    //         .subscribe({
    //             next: (accounts1) => {
    //                 if (accounts1) {
    //                     const accounts = accounts1?.list?.length > 0 ? accounts1?.list.filter((r) => r.statusId == 1).slice(0, 1000) : [];
    //                     if (formGroup.controls.selectedAccountDD) {
    //                         formGroup.controls.selectedAccountDD["customerAccOptions"] = accounts;
    //                         formGroup.controls.selectedAccountDD.setValue(accounts?.find((x) => x.id == accountId));
    //                     }
    //                 }
    //                 this.appMainService.isHideSpinner("getAccountList");
    //             },
    //             error: (error) => {
    //                 this.appMainService.isHideSpinner("getAccountList");
    //             },
    //             complete: () => {
    //                 this.appMainService.isHideSpinner("getAccountList");
    //             },
    //         });
    // }

    editJournalEntry(journalDetails: IJournal) {
        this.transactionDate = this.app._showDateTimeWithZone(journalDetails?.transactionDate);
        this.memo = journalDetails.memo;
        for (let tran of journalDetails?.accountTransactions) {
            this.editQuantity(tran);
        }
        for (const journal of this.journalForm.get("quantities")["controls"]) {
            // journal?.value?.debit == 0 ? journal.get("debit").disable() : true;
            // journal?.value?.credit == 0 ? journal.get("credit").disable() : true;
            if (journal?.value?.selectedAccountTypes?.value?.accountType?.name?.toLowerCase() == "account receivable" || journal?.value?.selectedAccountTypes?.value?.accountType?.name?.toLowerCase() == "account payable") {
                journal.get("userType").disable();
            }
        }
        this.calculateTotalDebitAmount();
        this.calculateTotalCreditAmount();
    }

    editedQuantity(accountTransaction: IFinanceAccountTransaction): FormGroup {
        const targetNodeId = accountTransaction.financialAccount?.id;
        const foundNode = this.financeUtilityService.findRecursiveChildObjects(this.accountTypes, targetNodeId);
        const cls = this.financeUtilityService.findRecursiveChildObjects(this.classes, accountTransaction?.classId);
        const userType = this.journalUserType.find((x) => x.id == accountTransaction?.accountListTypeId);
        let channel = null;
        let selectedAccountDD = null;
        const customerAccount = {
            id: accountTransaction.referenceId ?? 0,
            name: accountTransaction.businessName ?? "",
            businessName: accountTransaction.businessName ?? "",
            nameWithSequenceNumber: accountTransaction?.sequenceNumber + ' - ' + accountTransaction?.businessName,
            typeId: accountTransaction.channelId ?? 0,
        };

        if (userType?.id == 1) {
            channel = this.accountChannels.find((x: any) => x.id == accountTransaction?.channelId); //Customer
        } else if (userType?.id == 2) {
            selectedAccountDD = this.vendorAccounts?.find((x) => x.id == accountTransaction?.referenceId); //Vendor
        } else if (userType?.id == 3) {
            selectedAccountDD = this.allUser?.find((x) => x.id == accountTransaction?.referenceId); //employee
        } else if(userType?.id == 4) {
            selectedAccountDD = {
                id: 0,
                name: accountTransaction?.businessName ?? "",
            };
        }

        return this.fb.group({
            selectedAccountTypes: [foundNode, Validators.required],
            debit: [accountTransaction.amount > 0 ? accountTransaction.amount : 0, Validators.required],
            credit: [accountTransaction.amount < 0 ? accountTransaction.amount * -1 : 0, Validators.required],
            memo: [accountTransaction.lineMemo],
            userType: [userType, Validators.required],
            channel: [channel],
            selectedAccountDD: userType?.id == 1 ? [customerAccount] : [selectedAccountDD],
            class: [cls],
            id: [accountTransaction.id],
        });
    }

    editQuantity(accountTransaction: IFinanceAccountTransaction) {
        let formGroup = this.editedQuantity(accountTransaction);
        this.quantities().push(formGroup);
        // if (accountTransaction?.accountListTypeId == 1) {
        //     //Customer
        //     this.setAccountDDValue(accountTransaction.channelId, accountTransaction.referenceId, formGroup);
        // }
    }

    onEditManualJournalEntry(editType: typeJournalAddEditText) {
        if (!!this.statementMessage) {
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: ClosingYearDisplayMessages.lockMessage,
            });
            return;
        }
        if (this.financeUtilityService.validateJournalEntryDebitCredit(this.journalForm.get("quantities") as FormArray)) {
            for (let ctrl of this.journalForm.get("quantities")["controls"]) {
                ctrl.get("userType").enable();
            }
            let accountTransactions: IFinanceAccountTransaction[] = [];
            let totalCredit = 0;
            let totalDebit = 0;
            for (let jForm of this.journalForm.value.quantities) {
                const transaction = this.journalDetails?.accountTransactions?.find((x) => x.id == jForm?.id);
                if (jForm.credit) {
                    totalCredit += Number(jForm.credit);
                }
                if (jForm.debit) {
                    totalDebit += Number(jForm.debit);
                }
                let accountTransaction: IFinanceAccountTransaction = {
                    id: transaction?.id ?? 0,
                    createdSource: transaction?.createdSource ?? this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: transaction?.createdBy ?? this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: transaction?.createdDate ?? this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    accountTransactionMasterId: transaction?.accountTransactionMasterId ?? 0,
                    accountClientChartId: 0,
                    amount: jForm.debit ? Number(jForm.debit) : Number(jForm.credit) * -1,
                    financialAccountId: jForm.selectedAccountTypes.value?.id || 0,
                    financialAccount: null,
                    accountListTypeId: jForm.userType?.id || 0,
                    accountListType: null,
                    referenceId: jForm.selectedAccountDD?.id || 0,
                    lineMemo: jForm.memo,
                    transactionLineNumber: transaction?.transactionLineNumber ?? 0,
                    voidAmount: transaction?.voidAmount ?? 0,
                    businessName: jForm.selectedAccountDD?.name || this.otherName,
                    isBalanceEntry: transaction?.isBalanceEntry ?? false,
                    statusId: Status.ACTIVE,
                    classId: jForm.class?.id || 0,
                    channelId: jForm.userType && jForm.userType.name.toLowerCase() == "customer" && jForm.selectedAccountDD ? jForm.selectedAccountDD.typeId : 0,
                    isAdjustedEntry: this.isAdjustedEntry,
                };
                accountTransactions.push(accountTransaction);
            }
            let transactionDate = this.app._saveDateTimeWithZone(this.transactionDate, false);
            if (new Date(this.journalDetails?.transactionDate)?.toISOString()?.split("T")[0] == transactionDate?.toISOString()?.split("T")[0]) {
                transactionDate = this.journalDetails?.transactionDate;
            }

            const journal: IJournal = {
                id: this.journalDetails.id,
                createdSource: this.journalDetails.createdSource,
                updatedSource: this.app.userIP,
                createdBy: this.journalDetails.createdBy,
                updatedBy: this.app.user.userId,
                createdDate: this.journalDetails.createdDate,
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                organizationId: this.journalDetails.organizationId,
                transactionReferenceId: this.journalDetails.transactionReferenceId,
                accountsTransactionTypeId: this.journalDetails.accountsTransactionTypeId,
                accountTransactionType: this.journalDetails.accountTransactionType,
                referenceNumber: this.journalDetails.referenceNumber,
                memo: this.memo,
                referenceId: this.journalDetails.referenceId,
                transactionDate: transactionDate,
                accountsTransactionVoidId: this.journalDetails.accountsTransactionVoidId,
                accountTransactions: accountTransactions,
                businessName: this.journalDetails.businessName,
                channelId: this.journalDetails.channelId,
                isAdjustedEntry: this.isAdjustedEntry,
                txnNumber: this.journalDetails.txnNumber,
                postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.journalDetails?.postingDate,
                postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : this.journalDetails?.postingMonth,
                postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : this.journalDetails?.postingYear,
            };

            if (this.isDebitCreditEqual()) {
                this.financeService.editManualJournalEntry(journal).subscribe(
                    (res) => {
                        this.messageService.add({
                            severity: Severity.Success,
                            summary: this.titlecasePipe.transform(Severity.Success),
                            detail: "Journal Updated successfully...",
                        });
                        this.journalForm.reset();
                        this.totalDebit = 0;
                        this.totalCredit = 0;
                        this.onSuccessfullAddEdit.emit(editType);
                    },
                    (e) => {
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(Severity.Error),
                            detail: e?.error?.Message ?? "Error occurred...",
                        });
                    },
                );
            } else {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Total Debit and Total Credit must be equal...",
                });
            }
        } else {
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: " Each row must have either Debit or Credit",
            });
        }
    }
    isDebitCreditEqual(): boolean {
        return this.totalCredit.toFixed(this.fractionDigits) === this.totalDebit.toFixed(this.fractionDigits);
    }
    get debitCreditMismatchHighlighter(): { [key: string]: string } {
        return {
            color: this.isDebitCreditEqual() ? "" : "red",
        };
    }

    onDialogClose() {
        // this.isView = true;
        this.onCancelEdit.emit();
    }

    getAllClasses() {
        this.financeService.getAllClasses().subscribe((res) => {
            this.classes = this.financeUtilityService.prepareHierarchicalClassData(res);
        });
    }

    accountRecivablePayableSelectionDialog() {
        this.messageService.add({
            severity: "warn",
            summary: "Warning",
            detail: "Accounts recivable & Accounts payable can't be select on same transaction.",
        });
    }
    //#endregion

    onSelectUserTyeps2(event, i){
        this.userIndex = i;
        this.onChangeUserTypeFetchData();
    }
    onChangeUserTypeFetchData() {
        if(this.selectedUserType?.name == UserType.Customer){
            this.selectedAccountChannel = this.accountChannels[0];
            this.fetchAccounts();
        } else if(this.selectedUserType?.name ==  UserType.Vendor){
            this.fetchVendors();
        } else if(this.selectedUserType?.name == UserType.Employee){
            this.fetchUsers();
        } 
    }
    onChangePageFetchData(event) {
        this.pageNumber = event.first / event.rows + 1;
        this.pageSize = event.rows;
        this.first = event.first;
        this.onChangeUserTypeFetchData();
    }
    fetchVendors(){
        this.appMainService.isShowSpinner('loadvendor');
        this.productsService
        .getvendorsByPagination(this.pageNumber, this.pageSize, this.searchValue)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: (res) => {
                this.userlists = res?.body || [];
                const headers = res?.headers ? JSON.parse(res.headers.get('x-pagination')) : null;
                this.totalRecord = headers?.TotalCount || 0;
                this.appMainService.isHideSpinner('loadvendor');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('loadvendor');
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        });
    }
    fetchAccounts(){
        const requestModel: any = {
            channelId: this.selectedAccountChannel?.id || 1,
            isActive: true,
            selectableColumns: this.accSelectableColumns,
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,
            isSortByDescending: true,
            includeChildAccounts: false,
            globalSearchValue: this.searchValue,
        }

        this.appMainService.isShowSpinner('loadAccount');
        this.accountServiceN.getAccountsListWithFilters(requestModel)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: (response) => {
                if (response) {
                    this.userlists = response?.list?.map((x) => { return {...x, name: x?.businessName ?? "", children: [] }}) || [];
                    this.totalRecord = response?.totalNumberOfRows;
                }
                this.appMainService.isHideSpinner('loadAccount');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('loadAccount');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when loading accounts. Please try after sometime.'
                });
            },
            complete: () => {

            }
        });
    }
    fetchUsers(){
        this.appMainService.isShowSpinner('loaduser');
        this.financeService.fetchUserListByPagination(this.pageNumber, this.pageSize, this.searchValue)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: (response: any) => {
                if (response) {
                    this.userlists = response?.users || [];
                    this.totalRecord = response?.totalCount;
                }
                this.appMainService.isHideSpinner('loaduser');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('loaduser');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: "Error occurred...",
                });
            },
            complete: () => {

            }
        });
    }
    saveUser(){
        if(this.selectedUserType?.name?.toLowerCase() == 'other'){
            const user = {
                id: 0,
                name: this.otherName,
            }
            this.selectedUserList = user;
        }
        this.assignedUser = JSON.parse(JSON.stringify(this.selectedUserList));
        this.selectedUserList = null;
        this.displayUserList=false;

        const formGroup = this.journalForm.get('quantities')['controls'].at(this.userIndex) as FormGroup;
        formGroup.patchValue({
            userType: this.selectedUserType,
            channel: this.selectedAccountChannel,
            selectedAccountDD: this.assignedUser,
          });
    }
    removeAssignTo(i){
        this.assignedUser = null;
        const formGroup = this.journalForm.get('quantities')['controls'].at(i) as FormGroup;
        formGroup.get('selectedAccountDD').setValue(null);
    }
    assignUser(i) {
        this.userIndex = i;
        this.selectedUserList = null;
        this.selectedUserType = null;
        this.searchValue = "";
        this.otherName = "";
        this.displayUserList = true;
    }
    onSearchChange() {
        this.searchSubject.next(this.searchValue);
    }
    private setupSearch() {
        this.searchSubject.pipe(
          debounceTime(300),
          distinctUntilChanged(),
          tap(searchTerm => {
            this.searchValue = searchTerm;
            this.onChangeUserTypeFetchData();
          })
        ).subscribe();
    }
    expandedRows: { [key: number]: boolean } = {};
    onRowToggle(data: any) {
        this.expandedRows[data.id] = !this.expandedRows[data.id];
        if (this.expandedRows[data.id] && data.hasChildAccounts) {
            this.fetchChildAccounts(data);
        }
      }
      
      fetchChildAccounts(data: any) {
        const requestModel: any = {
            channelId: this.selectedAccountChannel?.id || 1,
            isActive: true,
            selectableColumns: ChildAccountSelectableColumns,
            pageSize: 0,
            pageNumber: 0,
            isSortByDescending: true,
            includeChildAccounts: false,
            globalSearchValue: this.searchValue,
            parentAccountId: data.id,
            stageId: null,
            filter: null,
            sortByColumn: null,
            filterInColumns: [],
        }
        this.appMainService.isShowSpinner('getAccountByParentId');
        this.accountServiceN.getAccountsList(requestModel)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    if (response) {
                        data.children = response?.list?.map((x) => { return {...x, name: x?.businessName ?? "", children: [] }}) || []; 
                        data.viewDetails = true;
                        this.expandedRows[data.id] = true;
                    }
                    this.appMainService.isHideSpinner('getAccountByParentId');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getAccountByParentId');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error!',
                        detail: 'Error occurring when loading accounts. Please try after sometime.'
                    });
                },
                complete: () => {

                }
            })
      }

    isClosingStatementDate(event: string) {
        this.statementMessage = event;
    }

   onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
        this.updatedPostingPeriodInfo = postingInfo;
      }
    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
